import { getTableList, 
    getManagerRank, 
    getColumnarData, 
    getRadarData, 
    getLineData, 
    getAltRank, 
    getOrderResultList, 
    getEngineerRank, 
    getEngineerRankBySite,
    getManagerOrg } from "@/api/indicators/api";
// import {demos} from "@/views/report/indicators/data/demo"
const indicators = {
    state: {
        lineData: {},
        columnarData: [],
        tableData: [],
        rankTableData: [],
        radarData: {},
        rankAltTableData: [],
        engineerRankTableData: [],
        engineerRankTableBySiteData: [],
        orderResultListData: [],
        // 详情传参
        showEdit: false,
        dataId: null,
        // 标签页参数
        activeName: 'first',
        // 列表页参数
        orderResultListQueryParams: {},
        showList: false,
        managerOrg: []
    },
    mutations: {
        SET_LINE_DATA(state, data) {
            state.lineData = data;
        },
        SET_COLUMNAR_DATA(state, data) {
            state.columnarData = data;
        },
        SET_TABLE_DATA(state, data) {
            state.tableData = data;
        },
        SET_RANK_TABLE_DATA(state, data) {
            state.rankTableData = data;
        },
        SET_RADAR_DATA(state, data) {
            state.radarData = data;
        },
        SET_ALT_RANK_TABLE_DATA(state, data) {
            state.rankAltTableData = data;
        },
        SET_ORDER_RESULT_LIST_DATA(state, data) {
            state.orderResultListData = data;
        },
        SET_ENGINEER_RANK_TABLE_DATA(state, data) {
            state.engineerRankTableData = data;
        },
        SET_ENGINEER_RANK_TABLE_BY_SITE_DATA(state, data){
            state.engineerRankTableBySiteData = data;
        },
        SET_SHOW_EDIT(state, data) {
            state.showEdit = data;
        },
        SET_DATA_ID(state, data) {
            state.dataId = data;
        },
        SET_ACTIVE_NAME(state, data) {
            state.activeName = data;
        },
        SET_ORDER_RESULT_LIST_QUERY_PARAMS(state, data) {
            state.orderResultListQueryParams = data;
        },
        SET_SHOW_LIST(state, data) {
            state.showList = data;
        },
        SET_MANAGER_ORG(state, data) {
            state.managerOrg = data;
        }
    },
    actions: {
        async GET_LINE_DATA({ commit }, params) {
            const response = await getLineData(params);
            commit('SET_LINE_DATA', response);
        },
        async GET_COLUMNAR_DATA({ commit }, params) {
            const response = await getColumnarData(params);
            commit('SET_COLUMNAR_DATA', response);
        },
        async GET_TABLE_DATA({ commit }, params) {
            const response = await getTableList(params);
            commit('SET_TABLE_DATA', response);
        },
        async GET_RANK_TABLE_DATA({ commit }, params) {
            const response = await getManagerRank(params); 
            commit('SET_RANK_TABLE_DATA', response);
        },
        async GET_RADAR_DATA({ commit }, params) {
            const response = await getRadarData(params);
            commit('SET_RADAR_DATA', response);
        },
        async GET_ALT_RANK_TABLE_DATA({ commit }, params) {
            const response = await getAltRank(params);
            commit('SET_ALT_RANK_TABLE_DATA', response);
        },
        async GET_ORDER_RESULT_LIST_DATA({ commit }, params) {
            const response = await getOrderResultList(params);
            commit('SET_ORDER_RESULT_LIST_DATA', response);
        },
        async GET_ENGINEER_RANK_TABLE_DATA({ commit }, params) {
            const response = await getEngineerRank(params);
            commit('SET_ENGINEER_RANK_TABLE_DATA', response);
        },
        async GET_ENGINEER_RANK_TABLE_BY_SITE_DATA({ commit }, params) {
            const response = await getEngineerRankBySite(params);
            commit('SET_ENGINEER_RANK_TABLE_BY_SITE_DATA', response);
        },
        async GET_MANAGER_ORG({ commit }, params) {
            const response = await getManagerOrg(params);
            commit('SET_MANAGER_ORG', response);
        }

    },
    getters: {
        lineData: state => state.lineData,
        columnarData: state => state.columnarData,
        tableData: state => state.tableData,
        rankTableData: state => state.rankTableData,
        radarData: state => state.radarData,
        rankAltTableData: state => state.rankAltTableData,
        engineerRankTableData: state => state.engineerRankTableData,
        engineerRankTableBySiteData: state => state.engineerRankTableBySiteData,
        showEdit: state => state.showEdit,
        dataId: state => state.dataId,
        activeName: state => state.activeName,
        orderResultListData: state => state.orderResultListData,
        orderResultListQueryParams: state => state.orderResultListQueryParams,
        showList: state => state.showList,
        managerOrg: state => state.managerOrg
    }
};

export default indicators;